import styled from "styled-components";
import React, { Component } from "react";

import { AiImagePresetStyles, AiImageStyleTypes } from "common/aiConstants";
import { AiImageStylePopup } from "js/editor/AiGeneration/GenerateImage/AiImageStyle";

const ImageStyleContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: white;
`;

export class ThemeImageStyles extends Component {
    handleImageStyleChange = selectedImageStyle => {
        if (selectedImageStyle === "**theme**") {
            return;
        }

        const presetStyle = AiImagePresetStyles.find(style => style.style === selectedImageStyle);
        if (presetStyle) {
            this.props.update({
                imageStyle: presetStyle.style,
                imageStylePrompt: presetStyle.prompt
            });
            return;
        }

        this.props.update({
            imageStyle: "custom",
            imageStylePrompt: selectedImageStyle
        });
    }

    render() {
        const imageStyle = this.props.theme.imageStyle || AiImageStyleTypes.MINIMALIST;
        const popupImageStyle = imageStyle === "custom"
            ? this.props.theme.imageStylePrompt
            : imageStyle;

        return (
            <ImageStyleContainer>
                <AiImageStylePopup
                    theme={this.props.theme}
                    imageStyle={popupImageStyle}
                    hideThemeImageStyle
                    onChange={this.handleImageStyleChange}
                />
            </ImageStyleContainer>
        );
    }
}
